export default __webpack_public_path__ + "static/media/acc.13c82bc1.svg";